module.exports = __webpack_public_path__ + "static/media/Dayly_ios_2_preview.b0d12aef.jpg";